import { validateDataMethods, validationEngine, } from "utils-library/dist/validation-engine";
export const validateCommentContent = (logContent) => validationEngine({
    validationRules: { body: value => validateDataMethods.isValidText(value, 1, 2000) },
    data: logContent,
});
